import axios from "axios";

const getAll = (callback) => {
    const config = {
        url: '/api/documents',
        method: 'GET',
    };

    axios.request(config).then(response => callback(response.data));
}

const get = (id, callback) => {
    const config = {
        url: `/api/documents/${id}`,
        method: 'GET',
    };

    axios.request(config).then(response => callback(response.data));
}

const save = (values, callback) => {
    const config = {
        url: values.id ? `/api/documents/${values.id}` : '/api/documents',
        method: values.id ? 'PUT' : 'POST',
        data: values
    };

    axios.request(config).then(response => callback(response.data));
}

const remove = (id, callback) => {
    const config = {
        url: `/api/documents/${id}`,
        method: 'DELETE',
    };

    axios.request(config).then(response => callback(response.data));
}

const DocumentActions = {
    getAll,
    get,
    save,
    remove,
}

export default DocumentActions;